var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeactivateUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Deactivate User") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-1529"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    fill: "#DD372F",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.663,12.71 L17.731,8.642 C17.9042867,8.47389291 17.9735546,8.22545987 17.9122481,7.99194373 C17.8509416,7.75842758 17.6685724,7.57605843 17.4350563,7.51475193 C17.2015401,7.45344543 16.9531071,7.52271329 16.785,7.696 L12.712,11.761 L8.643,7.696 C8.47489291,7.52271329 8.22645987,7.45344543 7.99294373,7.51475193 C7.75942758,7.57605843 7.57705843,7.75842758 7.51575193,7.99194373 C7.45444543,8.22545987 7.52371329,8.47389291 7.697,8.642 L11.763,12.71 L7.695,16.778 C7.44048819,17.0403537 7.44365943,17.4584156 7.70212191,17.7168781 C7.9605844,17.9753406 8.37864632,17.9785118 8.641,17.724 L12.712,13.661 L16.78,17.729 C17.0423537,17.9835118 17.4604156,17.9803406 17.7188781,17.7218781 C17.9773406,17.4634156 17.9805118,17.0453537 17.726,16.783 L13.663,12.71 Z",
    id: "deactivate_user_x_481442",
    stroke: "#FFFFFF",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateUser);
export default __webpack_public_path__ + "static/media/deactivate-user.3dbcabb4.svg";
export { ForwardRef as ReactComponent };